import React, { Component } from "react";
import _ from "lodash";
import { ResponsiveRadar } from "@nivo/radar";
import { SecondaryColor } from "../../utils/consts";

import "./locationScoreCard.css";
import SkeletonText from "../skeleton/SkeletonText";
import NoData from "../NoData/NoData";
import { ListingContext } from "../../Context";
export default class LocationScoreCard extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const { listing } = listingContext;

          //adjust data format to account for locationScore descriptions
          const locationScores = {};
          const locationScore = listing.locationScore || {};
          const Bike_Score = locationScore.Bike_Score || {};
          const Walk_Score = locationScore.Walk_Score || {};
          const Transit_Score = locationScore.Transit_Score || {};
          locationScores.Bike_Score = Bike_Score.Score;
          locationScores.Walk_Score = Walk_Score.Score;
          locationScores.Transit_Score = Transit_Score.Score;

          const scores = {
            ...listing.priceScore,
            ...locationScores,
            ...listing.guarenteeScore
          };

          //filter out invalid (NaN) or falsy scores
          const invalidScoreKeys = Object.keys(scores).filter(
            key => isNaN(scores[key]) || !scores[key]
          );
          invalidScoreKeys.forEach(key => delete scores[key]);
          return (
            <div
              style={this.props.height && { height: this.props.height }}
              className="location-score__radar-chart"
            >
              {listingContext.loading && <SkeletonText />}
              {!listingContext.loading &&
                !_.isEmpty(listingContext.listing) &&
                (!_.isEmpty(listingContext.listing.locationScore) ||
                  !_.isEmpty(listingContext.listing.priceScore)) && (
                  <ResponsiveRadar
                    data={Object.keys(scores).map(scoreName => {
                      // console.log(
                      //   scoreName.replace(/_/g, " ").replace("score", " score")
                      // );
                      return {
                        locationScore: scoreName.replace(/_/g, " "),
                        score: scores[scoreName] || 0
                      };
                    })}
                    keys={["score"]}
                    indexBy="locationScore"
                    maxValue="auto"
                    margin={{
                      top: 70,
                      right: 80,
                      bottom: 70,
                      left: 80
                    }}
                    curve="cardinalClosed"
                    borderWidth={3}
                    borderColor="inherit"
                    gridLevels={5}
                    gridShape="circular"
                    gridLabelOffset={36}
                    enableDots={true}
                    dotSize={8}
                    dotColor="inherit"
                    dotBorderWidth={0}
                    dotBorderColor="#ffffff"
                    enableDotLabel={true}
                    dotLabel="value"
                    dotLabelYOffset={-12}
                    colors={SecondaryColor}
                    colorBy="key"
                    fillOpacity={0.5}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    isInteractive={true}
                  />
                )}
              {!listingContext.loading &&
                (_.isEmpty(listingContext.listing) ||
                  (_.isEmpty(listingContext.listing.locationScore) &&
                    _.isEmpty(listingContext.listing.priceScore))) && (
                  <NoData topic="location score" />
                )}
            </div>
          );
        }}
      </ListingContext.Consumer>
    );
  }
}

// {
//   legends = {
//     [
//     {
//       anchor: "top-left",
//       direction: "column",
//       translateX: -50,
//       translateY: -40,
//       itemWidth: 80,
//       itemHeight: 20,
//       symbolSize: 12,
//       symbolShape: "circle"
//     }
//     ]}}



// WEBPACK FOOTER //
// ./src/components/locationScoreCard/LocationScoreCard.js